import { render, staticRenderFns } from "./AccordionListInsertItemAttribute.vue?vue&type=template&id=80f546f0&scoped=true"
import script from "./AccordionListInsertItemAttribute.vue?vue&type=script&lang=js"
export * from "./AccordionListInsertItemAttribute.vue?vue&type=script&lang=js"
import style0 from "./AccordionListInsertItemAttribute.vue?vue&type=style&index=0&id=80f546f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f546f0",
  null
  
)

export default component.exports